const style = {
  fontWeight: 400,
  fontSize: 14,
  lineHeight: 20
};
export const muiMuiListItemText = {
  styleOverrides: {
    root: style,
    primary: style
  }
};
